import type { Challenge, ChallengePreview, ChallengeType } from '~/types/challenge'

type LocalizableChallengeField = 'title' | 'note' | 'cover_photo'

export const challengeScoreLabelKey = (type: ChallengeType): string | null => {
  switch (type) {
    case 'distance':
      return 'Your Distance'
    case 'climb':
      return 'Your Climb'
    case 'duration':
      return 'Your Duration'
    case 'referral':
      return 'challenge_referral_score_label'
  }

  return null
}

export const resolveChallengeField = (
  challenge: Challenge | ChallengePreview,
  field: LocalizableChallengeField,
  locale: string
): string => {
  const lang = locale.split('-')[0]
  const localized = challenge[`${field}_${lang}` as keyof typeof challenge] as
    | string
    | undefined
  return localized || (challenge[field] as string)
}
